import { application } from "./application"

import DpagreementController from "./dpagreement_controller"
application.register("dpagreement", DpagreementController)

import FormValidatorController from "./form_validator_controller"
application.register("form-validator", FormValidatorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SyncController from "./sync_controller"
application.register("sync", SyncController)

import SyncProgressController from "./sync_progress_controller"
application.register("sync-progress", SyncProgressController)
